import React from 'react';
import store from '../store';
import { RESET_CITY,FILE_IMAGES,typeList,showTimeList,LBFormulaList,answerTimeList,qCountList,maxNumberList,digitsList,YesNoList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import _ from 'lodash'
const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%',
    maxWidth: 680
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  }
});
function searchLabel(array,value)
{
  let rel='';
  let index = array.findIndex(a=>a.value==value);
  if(index>-1)
  {
    rel = array[index].label;
  }
  return rel;
}
var _this;
const defaultSetting = {type:['image'],
times:1,
rows:3,
showTime:6,
answerTime:10,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
point_r:0,
point_pass:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
no_result:0,
rfrom:0,
rto:0
}

class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),
      open: false,
      curLevel:'easy',
      curType:'plus',

    }
    _this = this;
  }
  componentWillMount(){
    const { item } = this.state;
    if(!item.easy)
    {
      item.easy={};
      item.medium={};
      item.hard={};
      item.easy.plus=_.cloneDeep(defaultSetting);
      item.easy.multiple=_.cloneDeep(defaultSetting);
      item.easy.divide=_.cloneDeep(defaultSetting);
      item.easy.general=_.cloneDeep(defaultSetting);
      item.medium.plus=_.cloneDeep(defaultSetting);
      item.medium.multiple=_.cloneDeep(defaultSetting);
      item.medium.divide=_.cloneDeep(defaultSetting);
      item.medium.general=_.cloneDeep(defaultSetting);
      item.hard.plus=_.cloneDeep(defaultSetting);
      item.hard.multiple=_.cloneDeep(defaultSetting);
      item.hard.divide=_.cloneDeep(defaultSetting);
      item.hard.general=_.cloneDeep(defaultSetting);

    }
  }

  componentDidMount(props)
  {

  }





  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;

    item[name] = event.target.value;

    console.log(item);

    _this.setState({ item });
  }
  handleSettingChange = name => event => {
    event.preventDefault();
    const { item,curLevel,curType } = this.state;
    console.log(name,event.target.value);
    let curDay =  item[curLevel][curType];
    curDay[name] = event.target.value;

    _this.setState({ item });
  }
  handleDelete = (name,value) => {
    const { item,curLevel,curType } = this.state;
    let curDay =  item[curLevel][curType];
      let change = curDay[name];

      change = _.without(change,value);
      curDay[name] = change;

      this.setState({
          item
      });
  }




  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;

      const id = item.id;

      firebase.firestore().collection("challenges").doc('challenge').update(item)
        .then(function () {
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.forceUpdate();
        })
        .catch(function (error) {
          console.error(error);
        });

  }

  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };

  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,curLevel,curType } = this.state;

    let width=500;
    let levels = ['easy','medium','hard'];


    let curDay = {};
    if(item[curLevel] &&item[curLevel][curType])
    {
      curDay = item[curLevel][curType];
    }
  //  console.log(curDay.dba!=undefined?curDay.dba:1);
    const isEnabled = !item ? false : item.name ;
    return (<div>
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}><AllInboxIcon /></Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}></Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="body2" color="primary" style={{ marginBottom: 10 }}></Typography>
            <Divider style={{ marginBottom: 5 }} />
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.name}
                  onChange={this.handleChange('name')}
                  label="Name"
                  fullWidth
                  required
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>

            </Grid>


            <Divider />
            <div>



            <Divider />
            <Typography variant="body2" color="primary" style={{ marginTop: 10,color:'black' }}>Select Level</Typography>
            <Grid container alignItems="center" justify="center">
                  <Grid item >
                    <Button onClick={()=>{if(curLevel!='easy') this.setState({curLevel:'easy',curType:'plus'})}} style={{backgroundColor:curLevel=='easy'?'#1B5E20':'grey',color:'white',fontSize:20}}  size="large" variant="contained" color="secondary">
                      Easy
              </Button>
                  </Grid>
                  <Grid item >
                    <Button onClick={()=>{if(curLevel!='medium') this.setState({curLevel:'medium',curType:'plus'})}} style={{backgroundColor:curLevel=='medium'?'#1B5E20':'grey',color:'white',fontSize:20}}  size="large" variant="contained" color="secondary">
                      Medium
              </Button>
                  </Grid>
                  <Grid item >
                    <Button onClick={()=>{if(curLevel!='hard') this.setState({curLevel:'hard',curType:'plus'})}} style={{backgroundColor:curLevel=='hard'?'#1B5E20':'grey',color:'white',fontSize:20}}  size="large" variant="contained" color="secondary">
                      Hard
              </Button>
                  </Grid>

              </Grid>
              <Divider />
                <Typography variant="body2" color="primary" style={{ marginTop: 10,color:'black' }}>Select Type</Typography>
                <Grid container alignItems="center" justify="center">
                      <Grid item >
                        <Button onClick={()=>{if(curLevel!='plus') this.setState({curType:'plus'})}} style={{backgroundColor:curType=='plus'?'#1B5E20':'grey',color:'white',fontSize:15}}  size="large" variant="contained" color="secondary">
                          +/-
                  </Button>
                      </Grid>
                      <Grid item >
                        <Button onClick={()=>{if(curLevel!='multiple') this.setState({curType:'multiple'})}} style={{backgroundColor:curType=='multiple'?'#1B5E20':'grey',color:'white',fontSize:15}}  size="large" variant="contained" color="secondary">
                          x
                  </Button>
                      </Grid>
                      <Grid item >
                        <Button onClick={()=>{if(curLevel!='divide') this.setState({curType:'divide'})}} style={{backgroundColor:curType=='divide'?'#1B5E20':'grey',color:'white',fontSize:15}}  size="large" variant="contained" color="secondary">
                            ÷
                  </Button>
                      </Grid>
                      <Grid item >
                        <Button onClick={()=>{if(curLevel!='general') this.setState({curType:'general'})}} style={{backgroundColor:curType=='general'?'#1B5E20':'grey',color:'white',fontSize:15}}  size="large" variant="contained" color="secondary">
                          General
                  </Button>
                      </Grid>

                  </Grid>
                  <Divider />
              <div>
              <Typography variant="body2" color="primary" style={{ marginTop: 10,color:'black' }}>Settings for {curLevel}({curType}) </Typography>
              <Grid container direction="column" alignItems="center" justify="center" style={{ marginTop: 0 }}>

                  <Grid item >
                        <TextField
                            value={curDay.qCount}
                            onChange={this.handleSettingChange('qCount')}
                            label="Number of questions"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.5}}
                        >

                        </TextField>
                        <TextField
                            value={curDay.times}
                            onChange={this.handleSettingChange('times')}
                            label="Times to show"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            inputProps={{

                                 min: 1, max: 7
                            }}
                            style={{width:width*0.5}}/>

                  </Grid>

                  <Grid item >
                    <TextField
                        value={curDay.digits}
                        onChange={this.handleSettingChange('digits')}
                        label="Digits"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}
                        inputProps={{

                             min: 1, max: 7
                        }}
                        style={{width:width*0.49}}/>

                        <TextField
                            value={curDay.isReversed?curDay.isReversed:0}
                            onChange={this.handleSettingChange('isReversed')}
                            label="Is Super"
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.49}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>
                  </Grid>
                  <Grid item >

                        <TextField
                            value={curDay.lessThan0}
                            onChange={this.handleSettingChange('lessThan0')}
                            label="Less Than 0"
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.3}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>
                        <TextField
                            value={curDay.largerThan?curDay.largerThan:0}
                            onChange={this.handleSettingChange('largerThan')}
                            label={"Larger Than "+Math.pow(10,curDay.digits)}
                            placeholder=""
                            select
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.3}}


                        >
                        {YesNoList.map((t,index)=>{
                          return (<MenuItem key={"LessItem"+index} value={t.value}>
                        {t.label}
                      </MenuItem>)
                        })}
                        </TextField>


                  </Grid>


                  <Grid item >
                    <TextField
                        value={curDay.digits1}
                        onChange={this.handleSettingChange('digits1')}
                        label="Digits 1"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}
                        inputProps={{

                             min: 1, max: 7
                        }}
                        style={{width:width*0.3}}/>
                        <TextField
                            value={curDay.digits2}
                            onChange={this.handleSettingChange('digits2')}
                            label="Digits 2"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            inputProps={{

                                 min: 1, max: 7
                            }}
                            style={{width:width*0.3}}/>
                  </Grid>
                  <Grid item >

                    <TextField
                        value={curDay.dr1?curDay.dr1:0}
                        onChange={this.handleSettingChange('dr1')}
                        label="From Digit"
                        placeholder=""
                        type="number"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                            style: { color: '#1B5E20',fontSize:'1.2rem' }
                        }}

                        style={{width:width*0.3}}/>
                        <TextField
                            value={curDay.dr2?curDay.dr2:0}
                            onChange={this.handleSettingChange('dr2')}
                            label="To Digit"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}

                            style={{width:width*0.3}}/>
                          <TextField
                                value={curDay.dba!=undefined?curDay.dba:1}
                                onChange={this.handleSettingChange('dba')}
                                label="Divide by all"
                                placeholder=""
                                select
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#1B5E20',fontSize:'1.2rem' }
                                }}
                                style={{width:width*0.3,marginLeft:10}}>
                                {YesNoList.map((t,index)=>{
                                  return (<MenuItem key={"LessItem"+index} value={t.value}>
                                {t.label}
                              </MenuItem>)
                                })}
                              </TextField>
                  </Grid>

                  <Grid item xs={12}>
                      <Grid container direction="row" alignItems="center" justify="center" style={{ marginTop: 0 }}>

                          <Grid item >

                          </Grid>
                        </Grid>
                      <TextField
                          value={curDay.rows}
                          onChange={this.handleSettingChange('rows')}
                          onBlur={this.rownOnBlur}
                          label="Rows"
                          placeholder=""
                          type="number"
                          margin="normal"
                          InputLabelProps={{
                              shrink: true,
                              style: { color: '#1B5E20',fontSize:'1.2rem' }
                          }}
                          inputProps={{
                              style: {
                                padding: "5px 0px 5px 10px",
                                textAlign: "center",
                                height: "60px",
                                width: "60px",
                                border: "1px solid",
                                fontSize: "2rem",
                                backgroundColor:'#fff8ad'
                              },
                               min: 3, max: 40
                          }}


                      /><TextField
                          value={curDay.showTime}
                          onChange={this.handleSettingChange('showTime')}
                          label="Time"
                          placeholder=""
                          select
                          margin="normal"
                          InputLabelProps={{
                              shrink: true,
                              style: { color: '#1B5E20',fontSize:'1.2rem' }
                          }}
                          style={{marginLeft:"10px"}}


                      >
                      {showTimeList.map((t,index)=>{
                        return (<MenuItem key={"ShowTimeItem"+index} value={t.value}>
                      {t.label}
                    </MenuItem>)
                      })}
                      </TextField>
                      <TextField
                          value={curDay.answerTime}
                          onChange={this.handleSettingChange('answerTime')}
                          label="Answer Time"
                          placeholder=""
                          select
                          margin="normal"
                          InputLabelProps={{
                              shrink: true,
                              style: { color: '#1B5E20',fontSize:'1.2rem' }
                          }}
                          style={{marginLeft:"10px",width:width*0.3}}


                      >
                      {answerTimeList.map((t,index)=>{
                        return (<MenuItem key={"AnswerTimeItem"+index} value={t.value}>
                      {t.label}
                    </MenuItem>)
                      })}
                      </TextField>
                  </Grid>
                  <Grid item >
                        <TextField
                            value={curDay.point?curDay.point:0}
                            onChange={this.handleSettingChange('point')}
                            label="Point for each correct answer"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*1}}
                        >

                        </TextField>
                        </Grid>
                        <Grid item >
                        <TextField
                            value={curDay.point_r?curDay.point_r:0}
                            onChange={this.handleSettingChange('point_r')}
                            label="Point for each remain second"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*1}}
                        >

                        </TextField>

                  </Grid>
                  <Grid item >
                        <TextField
                            value={curDay.point_pass?curDay.point_pass:0}
                            onChange={this.handleSettingChange('point_pass')}
                            label="Point To Win"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*1}}
                        >

                        </TextField>
                  </Grid>
                  <Grid item >
                        <TextField
                            value={curDay.no_result?curDay.no_result:0}
                            onChange={this.handleSettingChange('no_result')}
                            label="No of results"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*1}}
                        >

                        </TextField>




                  </Grid>
                  <Grid item >
                        <TextField
                            value={curDay.rfrom?curDay.rfrom:0}
                            onChange={this.handleSettingChange('rfrom')}
                            label="Random from"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.5}}
                        >

                        </TextField>
                        <TextField
                            value={curDay.rto?curDay.rto:0}
                            onChange={this.handleSettingChange('rto')}
                            label="Random to"
                            placeholder=""
                            type="number"
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#1B5E20',fontSize:'1.2rem' }
                            }}
                            style={{width:width*0.5}}
                        >

                        </TextField>




                  </Grid>

              </Grid>
              </div>
            </div>






          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {/*!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>*/}
            {!item.id ? <Button onClick={()=>this.CreateItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
              <SaveIcon style={{ marginRight: 5 }} />Create
          </Button> :
              <Button onClick={()=>this.SaveItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
                <SaveIcon style={{ marginRight: 5 }} />SAVE
        </Button>}
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
